import React from 'react';
import Box from '@mui/material/Box';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Chip from '@mui/material/Chip';
import FieldLabel from '../components/FieldLabel';
import ErrorText from '../components/ErrorText';
import { getFieldLabel } from '../utils/formHelpers';

/**
 * Multiselect of trips (destinations/countries) a package should be linked to.
 * The trip the package is currently being configured from (`currentTripId`) is
 * always shown as a pinned, non-removable chip — the backend force-includes
 * it on save regardless of what's submitted, so disabling removal here avoids
 * a confusing "I removed it but it came back" experience.
 */
const TripSelectionField = ({
                                field,
                                data,
                                hasError,
                                change,
                                tripsList = [],
                                isTripsLoading = false,
                            }) => {
    const selectedIds = data[field.key] || [];

    const value = tripsList.filter((t) => selectedIds.includes(t.id));

    const handleChange = (event, newValue) => {
        change(field.key, newValue.map((item) => item.id));
    };

    return (
        <Box>
            <FieldLabel label={getFieldLabel(field)} tooltip={field.tooltip} />
            <Autocomplete
                multiple
                loading={isTripsLoading}
                options={tripsList}
                value={value}
                isOptionEqualToValue={(option, val) => option.id === val.id}
                getOptionLabel={(option) => option.title || option.primary_country || `Trip #${option.id}`}
                onChange={handleChange}
                renderTags={(tagValue, getTagProps) =>
                    tagValue.map((option, index) => (
                        <Chip
                            {...getTagProps({ index })}
                            key={option.id}
                            label={option.title || option.primary_country || `Trip #${option.id}`}
                        />
                    ))
                }
                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="outlined"
                        placeholder="Select trips (destinations)..."
                        error={hasError}
                    />
                )}
            />
            {hasError && <ErrorText message="Please select at least one trip" />}
        </Box>
    );
};

export default TripSelectionField;